import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowLeftIcon from 'assets/icons/longArrowLeft.svg';
import Skeleton from 'components/skeleton';
import ExternalLinkIcon from 'assets/icons/externalLink.svg';
import { DealItem } from 'models/partner';
import Btn from 'components/btn';
import DealCard, { DealModifier } from 'components/dealCard';

export interface PartnerDetailsHeaderProps {
  title: string;
  name: string | React.ReactElement;
  uri: string;
  btnText: string;
  deal: DealItem | null;
  isLoading: boolean;
}

function PartnerDetailsHeader(props: PartnerDetailsHeaderProps) {
  const { t } = useTranslation();
  const handleNavigation = (url: string) => {
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="ct_partnerDetailsHeader">
      <div className="ct_partnerDetailsHeader-nav">
        <Link to="/partners" className="ct_link _nav">
          <ArrowLeftIcon />
          {t('Back', { ns: 'partner' })}
        </Link>
      </div>
      <div className="ct_partnerDetailsHeader-main">
        <div className="ct_partnerDetailsHeader-title">{props.title}</div>
        <div className="ct_partnerDetailsHeader-name">{props.name}</div>
        <div className="ct_partnerDetailsHeader-actions">
          <Btn type="secondary" text={props.btnText} icon={<ExternalLinkIcon />} iconRight onClick={() => handleNavigation(props.uri)} />
        </div>
      </div>
      <div className="ct_partnerDetailsHeader-aside">
        <div className="ct_partnerDetailsHeader-asideInner">
          {props.isLoading && (
            <Skeleton height="452px" />
          )}
          {!props.isLoading && props.deal && (
            <DealCard deal={props.deal} modifier={DealModifier.FEATURED} isStatic />
          )}
        </div>
      </div>
    </div>
  );
}

export default PartnerDetailsHeader;
